import { getCustomSegmentTraits } from './customSegmentTraits';
import { customSegmentRef } from './consts';
import { getSnippetContent } from '../pluginComponentApi';

export default function (editor, opts = {}) {
  const { projectId, labelCustomSegment, version } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType(customSegmentRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          customSegmentUuid: '',
          icon: '<i class="wb webconnect-braces"></i>',
          'custom-name': opts.labelCustomSegment,
          projectId: projectId,
          version: version,
        },
        init() {
          getCustomSegmentTraits(projectId, version, labelCustomSegment).then((res) => {
            if (res) {
              this.addTrait(res, { at: 0 });
            }
          });
          this.on('change:customSegmentUuid', this.handleCollectionChange);
        },
        async handleCollectionChange() {
          const customSegmentUuid = this.get('customSegmentUuid');
          this.setAttributes({
            'data-customsegment-id': customSegmentUuid,
          });

          const selectedComponent = editor.getSelected();
          selectedComponent.empty();
          let serverUrl = process.env.REACT_APP_BUILDER_ENGINE;
          const { data: content } = await getSnippetContent(projectId, version, customSegmentUuid);
          if (content) {
            selectedComponent.append(
              content['nocode-html'] + `<style>${content['nocode-css']}</style>`,
            );
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === customSegmentRef) {
            return {
              type: customSegmentRef,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
}
